import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FileInfoType, FileService, SbeUploadEventTypes, FileUploadOptions } from '@schoolbelle/api/file';
import { BsModalRef } from "ngx-bootstrap/modal";
import { ModalsComponent } from '../modals.component';
import { filter, tap } from 'rxjs/operators';
import { FileUploadListOptions } from './file-upload-list.types';
import { Subscription } from 'rxjs';

@Component({
  selector: 'modal-file-upload-list',
  templateUrl: './file-upload-list-modal.component.html',
  styleUrls: ['./file-upload-list-modal.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class FileUploadListModalComponent extends ModalsComponent implements OnInit {
  @Input() list:Array<[File, FileUploadOptions]> = [];
  @Input() access_token:string;
  @Input() opts:FileUploadListOptions;  
  done:boolean = false;
  success_cnt = 0; 
  error_cnt = 0;
  uploadedMap:Map<any, FileInfoType>;
  subscription = new Subscription();
  constructor(
    modalRef:BsModalRef,
    protected file:FileService,
    protected cdRef:ChangeDetectorRef,
  ) { 
    super(modalRef);
  }

  ngOnInit() {
    if(this.list.length === 0) {
      return this.cancel();
    }
    this.uploadedMap = new Map();
    const errorMap = new Map();
    this.subscription.add(
      this.file.events.pipe(
        filter(e=>this.list.find(([file, opts])=>opts.upload_id === e.id) && (e.event.type === SbeUploadEventTypes.FileInfo || e.event.type === SbeUploadEventTypes.UploadError)),
        tap((e)=>{
          if (e.event.type === SbeUploadEventTypes.FileInfo) {
            const fileinfo = e.event.data;
            const index = e.id;
            this.uploadedMap.set(index, fileinfo);
            errorMap.delete(index);
          } else {
            const error = e.event.data;
            const index = e.id;
            errorMap.set(index, error);      
          }
          this.success_cnt = this.uploadedMap.size;
          this.error_cnt = errorMap.size;

          if (this.list.length === this.success_cnt + this.error_cnt) {
            this.done = true;
            this.cdRef.detectChanges();
          }
          if (this.opts.autoCloseWhenSuccess === true && this.success_cnt === this.list.length) this.ok(true);
        }),
      )
      .subscribe()
    );  
  }
  ngOnDestroy () {
    this.subscription.unsubscribe();
  }
  ok (val?:any) {
    super.ok(this.uploadedMap);
  }
}
